import { render } from "./HeaderKikirpa.vue?vue&type=template&id=52e3c490&scoped=true"
import script from "./HeaderKikirpa.vue?vue&type=script&lang=js"
export * from "./HeaderKikirpa.vue?vue&type=script&lang=js"

import "./HeaderKikirpa.vue?vue&type=style&index=0&id=52e3c490&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e3c490"]])

export default __exports__